import { Toaster as SonnerToaster } from 'sonner';
import { useTheme } from '../../hooks/useTheme';

/**
 * App-wide toast portal. Mounted once in App; consumers call
 * `toast.success(...)` / `toast.error(...)` from sonner directly.
 *
 * Position bottom-right matches the desktop convention but avoids
 * covering the top nav and the on-screen keyboard on tablets.
 *
 * Sonner has its own dark/light themes; we sync to the resolved
 * theme so toasts read correctly in dark mode without us having to
 * style every variant manually.
 */
export function AppToaster() {
  const { resolved } = useTheme();
  return (
    <SonnerToaster
      position="bottom-right"
      richColors
      closeButton
      duration={3500}
      theme={resolved === 'dark' ? 'dark' : 'light'}
      toastOptions={{
        className:
          'font-sans rounded-token shadow-token-lg border border-line/10',
      }}
    />
  );
}
